import { render, staticRenderFns } from "./recipesPage.vue?vue&type=template&id=218f4be0&"
import script from "./recipesPage.vue?vue&type=script&lang=js&"
export * from "./recipesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports